module.exports = __webpack_public_path__ + "static/media/slider_button.5a7cc5ae.svg";